import { render } from "./cyclingjerseys.vue?vue&type=template&id=4b655fa1&scoped=true"
import script from "./cyclingjerseys.vue?vue&type=script&lang=js"
export * from "./cyclingjerseys.vue?vue&type=script&lang=js"

import "./cyclingjerseys.vue?vue&type=style&index=0&id=4b655fa1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b655fa1"]])

export default __exports__